import { useMemo } from 'react';
import MojitoPresentation from 'mojito/presentation';
import BonusIndicator from 'modules/bonus-indicator/index.js';
import BonusIndicatorTypes from 'modules/bonus-indicator/types.js';

const { FlexPane, Image, Text, DateTime, NeutralVenueIndicator } = MojitoPresentation.Components;

const INFO_ORDER = {
    SELECTION_FIRST: 'selectionFirst',
    EVENT_FIRST: 'eventFirst',
};

const MatchAccaSelectionItemAvantgarde = props => {
    const {
        showSeparator,
        selectionLabel,
        marketName,
        eventName,
        earlyPayout,
        eventStartTime,
        price,
        basePrice,
        neutral,
        mojitoTools: { config, style, stringResolver },
    } = props;
    const hasEarlyPayout = !!earlyPayout;
    const bonusInfo = useMemo(() => ({ rules: earlyPayout?.rules }), [earlyPayout]);
    const { showPartMetadata } = config;
    const hasRowDivider = config.showRowDivider && showSeparator;

    const selectionLabelText = (
        <Text config={config.selectionLabel} class="ta-MatchAccaSelectionName">
            {selectionLabel}
            {marketName && (
                <>
                    <span>{` ${stringResolver.resolveString('$MATCH_ACCA_SELECTION_ITEM.SEPARATOR')} `}</span>
                    <span style={config.marketName}>{marketName}</span>
                </>
            )}
        </Text>
    );

    const eventNameText = eventName && (
        <Text config={config.eventName} class="ta-MatchAccaEventName">
            {eventName}
        </Text>
    );

    const earlyPayoutIndicator = hasEarlyPayout && (
        <BonusIndicator
            class="ta-earlyPayoutIndicator"
            config={config.earlyPayoutIndicator}
            bonusType={BonusIndicatorTypes.TYPES.EARLY_PAYOUT}
            bonusInfo={bonusInfo}
            isAwarded={earlyPayout.awarded}
        />
    );

    const eventMeta = (eventStartTime || hasEarlyPayout || neutral) && (
        <FlexPane config={config.eventMetaContainer} class="ta-MatchAccaEventMeta">
            {eventStartTime && (
                <Text config={config.eventStartTime} class="ta-MatchAccaEventStartTime">
                    <DateTime config={config.eventStartTimeFormat} dateTime={eventStartTime} />
                </Text>
            )}
            {earlyPayoutIndicator}
            {neutral && <NeutralVenueIndicator config={config.neutralVenueIndicator} />}
        </FlexPane>
    );

    const partPrice = price && (
        <FlexPane config={config.priceContainer} class="ta-MatchAccaPartPrice">
            {basePrice && (
                <Text config={config.basePrice} class="ta-basePrice">
                    {basePrice}
                </Text>
            )}
            <Text config={config.price} class="ta-price">
                {price}
            </Text>
        </FlexPane>
    );

    const selectionInfo = showPartMetadata ? (
        <FlexPane config={config.selectionLabelRow} class="ta-MatchAccaSelectionLabelRow">
            {selectionLabelText}
            {partPrice}
        </FlexPane>
    ) : (
        selectionLabelText
    );

    const eventInfo =
        showPartMetadata && (eventNameText || eventMeta) ? (
            <FlexPane config={config.eventNameRow} class="ta-MatchAccaEventNameRow">
                {eventNameText}
                {eventMeta}
            </FlexPane>
        ) : (
            eventNameText
        );

    const [firstInfo, secondInfo] =
        config.infoOrder === INFO_ORDER.EVENT_FIRST
            ? [eventInfo, selectionInfo]
            : [selectionInfo, eventInfo];

    return (
        <FlexPane
            config={hasRowDivider ? style.selectionContainerWithDivider : config.selectionContainer}
            class="ta-MatchAccaSelectionItem"
        >
            <FlexPane config={config.selectionIconContainer} class="ta-selectionIconContainer">
                <Image config={config.selectionIcon} class="ta-SingleBet-selectionIcon" />
            </FlexPane>
            <FlexPane config={config.marketInfoContainer}>
                {firstInfo}
                {secondInfo}
                {!showPartMetadata && hasEarlyPayout && (
                    <FlexPane config={config.labelsContainer}>{earlyPayoutIndicator}</FlexPane>
                )}
            </FlexPane>
        </FlexPane>
    );
};

MatchAccaSelectionItemAvantgarde.getStyle = (config, mode, merge) => ({
    selectionContainerWithDivider: merge(config.selectionContainer, config.rowDivider),
});

export default MatchAccaSelectionItemAvantgarde;
